
import { useState } from 'react';

const testimonials = [
  {
    text: "Data Health Insurance Consultants found me private health insurance coverage that saved me over $200 a month. Their 24/7 availability meant I got answers at 11 PM when I needed them most. Best insurance broker in Houston.",
    name: "Maria Gonzalez",
    role: "Small Business Owner",
    location: "Montrose, Houston",
    image: "https://public.readdy.ai/ai/img_res/4525a3c9739ccc2d8eb15ce5a8d88978.jpg",
  },
  {
    text: "As a startup founder, I needed affordable group health insurance for my team fast. Data Health compared dozens of plans and had us covered within a week. Their Houston expertise made all the difference.",
    name: "James Mitchell",
    role: "Tech Startup CEO",
    location: "Midtown, Houston",
    image: "https://readdy.ai/api/search-image?query=professional%20african%20american%20male%20tech%20entrepreneur%20smiling%20confident%20headshot%20portrait%20clean%20white%20background%20warm%20natural%20lighting&width=200&height=200&seq=dtest002&orientation=squarish",
  },
  {
    text: "After turning 65, Medicare options were overwhelming. The team at Data Health walked me through every supplement plan available in Houston. I feel confident in my coverage now. Truly caring professionals.",
    name: "Robert Chen",
    role: "Retired Engineer",
    location: "Sugar Land, Houston",
    image: "https://readdy.ai/api/search-image?query=friendly%20senior%20asian%20american%20man%20smiling%20warmly%20headshot%20portrait%20clean%20white%20background%20natural%20lighting%20retired%20professional&width=200&height=200&seq=dtest003&orientation=squarish",
  },
  {
    text: "I was between jobs and needed short-term health insurance immediately. Data Health Insurance got me covered the very next day. Their free consultation saved me from making a costly mistake with the wrong plan.",
    name: "Sarah Thompson",
    role: "Marketing Director",
    location: "The Heights, Houston",
    image: "https://readdy.ai/api/search-image?query=professional%20young%20woman%20marketing%20director%20smiling%20headshot%20portrait%20clean%20white%20background%20warm%20natural%20lighting%20blonde%20hair&width=200&height=200&seq=dtest004&orientation=squarish",
  },
  {
    text: "We switched our company's group health insurance through Data Health and our employees are thrilled. Better coverage, lower premiums, and the ongoing support has been exceptional. Highly recommend for Houston businesses.",
    name: "David Patel",
    role: "HR Director",
    location: "Katy, Houston",
    image: "https://readdy.ai/api/search-image?query=professional%20south%20asian%20male%20HR%20director%20smiling%20confident%20headshot%20portrait%20clean%20white%20background%20warm%20natural%20lighting%20business%20attire&width=200&height=200&seq=dtest005&orientation=squarish",
  },
  {
    text: "Finding private health insurance for my family of five seemed impossible until we found Data Health. They compared plans across multiple carriers and found coverage that fit our budget perfectly. Available anytime we had questions.",
    name: "Jennifer Williams",
    role: "Mother of Three",
    location: "Memorial, Houston",
    image: "https://readdy.ai/api/search-image?query=friendly%20young%20mother%20smiling%20warmly%20headshot%20portrait%20clean%20white%20background%20warm%20natural%20lighting%20casual%20professional%20look&width=200&height=200&seq=dtest006&orientation=squarish",
  },
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  const visible = [
    testimonials[current],
    testimonials[(current + 1) % testimonials.length],
    testimonials[(current + 2) % testimonials.length],
  ];

  const next = () => setCurrent((p) => (p + 1) % testimonials.length);
  const prev = () => setCurrent((p) => (p - 1 + testimonials.length) % testimonials.length);

  return (
    <section id="testimonials" className="py-24 bg-navy-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-72 h-72 rounded-full border border-brand-400"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full border border-brand-400"></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-8 lg:px-12 relative z-10">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 text-brand-400 text-sm font-semibold tracking-wider uppercase mb-3">
            <span className="w-8 h-[2px] bg-brand-400"></span>
            Testimonials
            <span className="w-8 h-[2px] bg-brand-400"></span>
          </span>
          <h4 className="text-4xl font-display font-bold text-white mb-3">
            <a href="#testimonials" className="text-white hover:text-brand-300 transition-colors">
              What Houston Residents Say
            </a>
          </h4>
          <p className="text-navy-300 text-base max-w-xl mx-auto">
            Real stories from Houston individuals and businesses who found better private health
            insurance through our consultants.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {visible.map((t, i) => (
            <article
              key={`${current}-${i}`}
              className="bg-navy-800/60 backdrop-blur-sm rounded-xl p-8 border border-navy-700/50 hover:border-brand-500/30 transition-all duration-300"
            >
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-amber-400 text-base"></i>
                ))}
              </div>
              <p className="text-white/90 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={t.image}
                  alt={`${t.name} - ${t.role} in ${t.location}`}
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <div className="text-white font-semibold text-sm">{t.name}</div>
                  <div className="text-brand-400 text-xs">{t.role}</div>
                  <div className="text-navy-400 text-xs">{t.location}</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="flex items-center justify-center gap-4">
          <button
            onClick={prev}
            className="w-10 h-10 rounded-full border border-brand-500 text-brand-400 flex items-center justify-center hover:bg-brand-500 hover:text-white transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <div className="flex gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  i === current ? 'w-8 bg-brand-500' : 'w-2 bg-navy-600'
                }`}
              ></button>
            ))}
          </div>
          <button
            onClick={next}
            className="w-10 h-10 rounded-full border border-brand-500 text-brand-400 flex items-center justify-center hover:bg-brand-500 hover:text-white transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
